import {INIT_URL, SIGNOUT_USER_SUCCESS, SIGNIN_USER_SUCCESS, ACCESS_TOKEN_SET} from "../../constants/ActionTypes";

const INIT_STATE = {
  userid: null,
  username: null,
  email: null,
  initURL: '',
  permissions: [],
  access_token: localStorage.getItem('access_token') !== 'undefined' ? JSON.parse(localStorage.getItem('access_token')) : null,
  refresh_token: null,
  expires_in: null,
  organisation: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        userid: null,
        username: null,
        initURL: '',
        permissions: [],
        access_token: null,
        refresh_token: null,
        expires_in: null,
        organisation: null,
      }
    }

    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token,
        expires_in: action.payload.expires_in,
      };
    }

    case ACCESS_TOKEN_SET: {
      return {
        ...state,
        userid: action.payload.userid,
        username: action.payload.username,
        email: action.payload.email,
        permissions: action.payload.permissions,
        mode: action.payload.mode,
        organisation: action.payload.organisation,
      }
    }

    default:
      return state;
  }
}
